import { IGetArquivoNotaFiscalUseCase } from "../../../presentation/useCases/read/get_arquivo_nota_fiscal_use_case";

import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class GetArquivoNotaFiscalUseCase implements IGetArquivoNotaFiscalUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async getArquivoNotaFiscal(
    IdGestaoRecebimentoEpi: number,
    imageName: string,
  ): Promise<void> { 
    const blob = await this.repository.getArquivoNotaFiscal(IdGestaoRecebimentoEpi);
   if (!blob) throw new Error("Falha ao buscar dados da imagem!");

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", String(imageName));
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
